import PusherService from '@/app/services/PusherService';

/**
 * 새로고침/구독해제 를 적용하지 않을 경로.
 * 새로고침 시 진행 중이던 게임 상태가 유실되는 페이지는 제외한다. (DKT-1208)
 */
const EXCLUDED_PATHS = ['/app/typing/in-play'];

function isExcludedPage(): boolean {
    return EXCLUDED_PATHS.some((path) => window.location.pathname.startsWith(path));
}

/**
 * 탭 비활성/활성 전환 시 stale UI 및 메시지 race 를 방지한다.
 *
 * - 탭이 비활성화되면 Pusher 연결을 끊어 백그라운드에서 store 가 갱신되는 것을 차단한다.
 * - 다시 활성화되면 무조건 페이지를 새로고침해 서버에서 최신 state 를 다시 받는다.
 * - SPA 내 페이지 이동 후에도 리스너가 유지되므로 제외 여부는 이벤트 발생 시점의 경로로 판단한다.
 *
 * (DKT-1026)
 */
export function setupTabVisibilityRefresh(): void {
    if (typeof document === 'undefined') {
        return;
    }

    document.addEventListener('visibilitychange', () => {
        if (isExcludedPage()) {
            return;
        }

        if (document.visibilityState === 'hidden') {
            PusherService.getInstance().unsubscribeClassChannel();
            return;
        }

        if (document.visibilityState === 'visible') {
            window.location.reload();
        }
    });
}
